var map = {
	"./button-secondary-hover.png": 25,
	"./button-secondary-hover@2x.png": 26
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 181;



//////////////////
// WEBPACK FOOTER
// ./img/btn ^\.\/button\-secondary\-hover.*\.png$
// module id = 181
// module chunks = 3